import FaceEmoji from "./FaceEmoji";

export default FaceEmoji;
export * from "./constants";
